(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cabin-header"] && !Shopify.designMode) return;
  try {
    
class CabinCartStatus extends HTMLElement {
  #controller;
  #generation = 0;

  connectedCallback() {
    this.#controller?.abort();
    this.#controller = new AbortController();
    const options = { signal: this.#controller.signal };
    document.addEventListener('shopify:cart:lines-update', this.#onCartUpdate, options);
    window.addEventListener('pageshow', this.#onPageShow, options);
    this.querySelector('[data-cr-cart-dismiss]')?.addEventListener('click', this.#hideNotice, options);
  }

  disconnectedCallback() {
    this.#generation += 1;
    this.#controller?.abort();
  }

  #setCount(count) {
    if (!Number.isInteger(count) || count < 0) return;
    const target = this.querySelector('[data-cr-cart-count]');
    if (target) target.textContent = String(count);
  }

  #hideNotice = () => {
    const notice = this.querySelector('[data-cr-cart-notice]');
    if (notice) notice.hidden = true;
    const message = this.querySelector('[data-cr-cart-message]');
    if (message) message.textContent = '';
  };

  #onCartUpdate = (event) => {
    const generation = ++this.#generation;
    this.#hideNotice();
    event.promise?.then(({ cart, detail, userErrors, warnings }) => {
      if (!this.isConnected || generation !== this.#generation) return;
      this.#setCount(cart?.totalQuantity);
      if (event.action !== 'add' || detail?.didError || userErrors?.length || warnings?.length) return;
      if (!cart || cart.totalQuantity < 1) return;
      const notice = this.querySelector('[data-cr-cart-notice]');
      const message = this.querySelector('[data-cr-cart-message]');
      if (notice && message) {
        notice.hidden = false;
        message.textContent = message.dataset.addedMessage || '';
      }
    }).catch(() => {});
  };

  #onPageShow = async (event) => {
    if (!event.persisted || !this.dataset.cartUrl) return;
    const generation = ++this.#generation;
    this.#hideNotice();
    try {
      const response = await fetch(`${this.dataset.cartUrl}.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        signal: this.#controller.signal,
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (this.isConnected && generation === this.#generation) this.#setCount(cart.item_count);
    } catch {}
  };
}

if (!customElements.get('cabin-cart-status')) {
  customElements.define('cabin-cart-status', CabinCartStatus);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
